export default [
  // 功能说明
  {
    path: '/introduce',
    component: () => import('../../views/atmosphere/Introduce.vue'),
    name: 'introduce',
    meta: {
      translateKey: 'cfmoto.functionIntroduce',
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
  {
    path: '/lamp',
    component: () => import('../../views/atmosphere/Lamp.vue'),
    name: 'lamp',
    meta: {
      translateKey: 'cfmoto.IndicatorLight',
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-gray',
    },
  },
];
